import React, { useState } from 'react';
import {
  Card,
  Grid,
  Avatar,
  Typography,
  Box,
  IconButton,
  Tooltip,
  Button,
  useMediaQuery,
} from '@mui/material';
import { useAccount } from '../../contexts/Account';
import eventBus, { eventBusValues } from '../../eventBus';
import { getAdvisorImagePath } from '../../services/utils';
import ShareItemsMultiAccount from '../../components/ShareItemsMultiAccount';

export default function BoardroomHeader({
  advisor,
  setSuccessSnackbar,
  setSuccessMessage,
}) {
  const { accountDetails } = useAccount();
  const publicProfile = `advisorycloud.com/profile/${advisor.publicProfileUrl}`;
  const [openTooltip, setOpenTooltip] = useState(false);
  const isWrapped = useMediaQuery('(min-width:1279px) and (max-width:1450px)');

  function copyToClipboard() {
    navigator.clipboard.writeText(publicProfile);
    setSuccessMessage('Profile link has been copied to your clipboard.');
    setSuccessSnackbar(true);
  }

  const onClick = () =>
    eventBus.dispatch(eventBusValues.triggerAdvisorDrawerAction, {
      ...accountDetails,
      openInEdit: false,
    });

  return (
    <>
      <Card
        sx={{
          p: 3,
          borderRadius: '8px',
          boxShadow: 'none',
          mt: 0,
        }}
      >
        <Grid container spacing={3} alignItems="center" justifyContent="center">
          <Grid item sx={{ pl: isWrapped ? 0 : 2 }}>
            <Box
              onClick={onClick}
              id="advisor-boardroom-avatar"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: { xxs: 128, xs: isWrapped ? 150 : 207 },
                height: { xxs: 128, xs: 207 },
                borderRadius: '8px',
                cursor: 'pointer',
              }}
            >
              <Avatar
                alt={`${advisor.givenName} Logo`}
                src={getAdvisorImagePath(advisor)}
                sx={{
                  width: { xxs: 100, xs: 150 },
                  height: { xxs: 100, xs: 150 },
                  borderRadius: '8px',
                }}
              />
            </Box>
          </Grid>
          <Grid item>
            <Typography
              id="boardroom-advisor-name"
              sx={{
                fontWeight: '600',
                fontSize: { xxs: 24, xs: 40 },
                textAlign: { xxs: 'center', xs: 'left' },
                lineHeight: '41px',
                color: '#001030',
              }}
            >
              Welcome,
              <Typography
                component="span"
                sx={{
                  fontWeight: '600',
                  fontSize: { xxs: 24, xs: 40 },
                  lineHeight: '41px',
                  color: '#2B71F6',
                  marginLeft: '7px',
                }}
              >
                {advisor.givenName}.
              </Typography>
            </Typography>
            <Box
              sx={{
                display: { xxs: 'block', xs: 'flex' },
                justifyContent: 'flex-start',
                mt: 2,
                gap: isWrapped ? 1 : 2,
              }}
            >
              <Typography
                sx={{
                  fontWeight: '700',
                  fontSize: '12px',
                  lineHeight: '150%',
                  letterSpacing: '0%',
                  color: '#4D586F',
                  marginTop: '8px',
                  mb: { xxs: '9px', xs: 0 },
                }}
              >
                AdvisoryCloud Profile URL:
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Button
                  variant="outlined"
                  id="profile-url-button"
                  sx={{
                    textTransform: 'none',
                    borderRadius: '10px',
                    border: '1px solid #EFF0F7',
                    whiteSpace: 'nowrap',
                    height: '35px',
                    color: '#232B35',
                    fontSize: { xxs: 12, xs: 14 },
                    fontWeight: '400',
                    overflow: 'hidden',
                    padding: '0',
                    maxWidth: {
                      xxs: publicProfile.length > 40 ? '270px' : 'none',
                      xs: isWrapped ? '290px' : 'none',
                    },
                  }}
                  onClick={copyToClipboard}
                >
                  <Box
                    sx={{
                      overflow: 'hidden',
                      padding: '5px 15px',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      width: '100%',
                    }}
                  >
                    {publicProfile}
                  </Box>
                </Button>
                <Tooltip
                  title="We recommend you share your Advisor Profile URL wherever you have the most professional contacts or visibility to help attract advisory work and connections you care about."
                  placement="top"
                  arrow
                  open={openTooltip}
                  onClose={() => setOpenTooltip(false)}
                >
                  <Box
                    sx={{
                      width: 22,
                      height: 22,
                      borderRadius: '50%',
                      backgroundColor: '#fff',
                      border: '1px solid #4FB5F9',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mt: '0px',
                    }}
                  >
                    <IconButton
                      size="small"
                      sx={{ color: '#666', p: 0, fontSize: 12 }}
                      onClick={() => setOpenTooltip(true)}
                      onMouseEnter={() => setOpenTooltip(true)}
                    >
                      i
                    </IconButton>
                  </Box>
                </Tooltip>
              </Box>
            </Box>
            <ShareItemsMultiAccount isAdvisor />
          </Grid>
        </Grid>
      </Card>
    </>
  );
}
